<template>
  <div
    class="note-tile"
    :class="{'customer-visible': note.customerVisible}"
  >
    <div class="note-tile-content">
      {{ note.content }}
      <div
        v-if="note.lastModifiedByUser && note.lastModifiedDate"
        class="audit-info"
      >
        {{ note.lastModifiedByUser.firstName }} {{ note.lastModifiedByUser.lastName }} {{ $methods.formatDate(note.lastModifiedDate) }}
      </div>
    </div>
    <DotsSvg @click.stop="onDotsClicked" />
    <div
      v-if="showMenu"
      class="menu"
    >
      <div v-click-outside="closeMenu">
        <div
          class="menu-option"
          @click="onEditNoteClicked"
        >
          Edit Note
        </div>
        <div
          class="menu-option"
          @click="onDeleteNoteClicked"
        >
          Delete Note
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Note } from '@/@types/responses/note/Note'
import { defineComponent } from 'vue'
import DotsSvg from '@/components/svgs/DotsSvg.vue'

export default defineComponent({
  name: 'NoteTile',
  components: {
    DotsSvg
  },
  props: {
    note: {
      type: Note,
      required: true
    }
  },
  emits: ['delete', 'edit'],
  data() {
    return {
      showMenu: false
    }
  },
  methods: {
    closeMenu(): void {
      this.showMenu = false
    },
    onDeleteNoteClicked(): void {
      this.closeMenu()
      this.$emit('delete', this.note)
    },
    onDotsClicked(): void {
      this.showMenu = true
    },
    onEditNoteClicked(): void {
      this.closeMenu()
      this.$emit('edit', this.note)
    }
  }
})
</script>

<style scoped lang="scss">
.note-tile {
  position: relative;
  background-color: $Color-fill-gray;
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 15px;
  display: flex;

  &.customer-visible {
    background-color: $Color-sac-orange;
  }

  &:last-of-type {
    margin-bottom: 0;
  }

  > .note-tile-content {
    flex: 0 0 90%;
    width: 90%;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    color: $Color-font-high;
    white-space: pre-wrap;

    > .audit-info {
      margin-top: 10px;
      font-size: 12px;
      line-height: 18px;
      font-weight: normal;
      color: $Color-font-medium;
    }
  }

  > svg {
    flex: 0 0 10%;
    margin: auto 10px;
  }

  > .menu {
    @include menu;
  }
}
</style>